import type { AccountingSettingsFormValues } from "./schemas/accountingSettingsForm"

import type { AccountingSettings, UpdateAccountingSettingsInput } from "@/graphql/codegen/graphql"

export const toAccountingSettingsFormValues = (settings?: AccountingSettings): AccountingSettingsFormValues => ({
  paymentByAchOrVirtualCcLeadDays: settings?.paymentByAchOrVirtualCcLeadDays ?? null,
  paymentByCheckLeadDays: settings?.paymentByCheckLeadDays ?? null,
  paymentByWireLeadDays: settings?.paymentByWireLeadDays ?? null,
})

// Callers must only invoke after schema validation has passed — `null` values are
// rejected by the schema so the non-null assertions are safe here.
export const toAccountingSettingsUpdateInput = (
  formValues: AccountingSettingsFormValues
): UpdateAccountingSettingsInput => ({
  paymentByAchOrVirtualCcLeadDays: formValues.paymentByAchOrVirtualCcLeadDays!,
  paymentByCheckLeadDays: formValues.paymentByCheckLeadDays!,
  paymentByWireLeadDays: formValues.paymentByWireLeadDays!,
})
